import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageProps } from "../types/auth";

import styles from './styles/CreateCurriculumPage.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CreateCurriculumPage: React.FC<PageProps> = ({ token, selectedOrgID }) => {
  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const nameInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/api/curriculums`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Org-ID": selectedOrgID?.toString() || "",
        },
        body: JSON.stringify({
          name,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.error || "Failed to create curriculum.");
        return;
      }

      navigate("/curriculums");
    } catch (err) {
      setError("An unexpected error occurred.");
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Create Curriculum</h1>
      {error && <p className={styles.errorMessage}>{error}</p>}
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Curriculum Name:</label>
          <input
            ref={nameInputRef}
            type="text"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <button type="submit" className={styles.submitButton}>Create Curriculum</button>
      </form>
    </div>
  );
};

export default CreateCurriculumPage;
